/*
 * @Author: H 
 * @Date: 2019-12-02 11:51:11 
 * @Last Modified by: AloneH
 * @Last Modified time: 2020-01-07 17:21:14
 */

import axios from 'axios'


axios.defaults.withCredentials = true;
// axios.defaults.baseURL = process.env.HOST;
axios.defaults.timeout = 60000;
axios.defaults.retry = 4;
axios.defaults.retryDelay = 6000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


/**
 * @description: post网络请求
 * @param {string} url
 * @param {object} params
 * @return: Promise
 */
export function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err)
            })
            .catch((error) => {
                alert('网络超时请重新刷新')
            })

    })
}


/**
 * @description: get网络请求
 * @param {string} url
 * @param {object} params
 * @return: Promise
 */
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: param })
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch(error => {
                alert('网络超时请重新刷新')
            })
    })
}


export default {
    fetchPost,
    fetchGet
}


// WEBPACK FOOTER //
// ./src/http.js